import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye, LogOut } from "lucide-react";
import { viewerApi, errMsg } from "@/lib/api";
import { Logo } from "@/components/Layout";
import { PlayCard } from "@/components/PlayCard";
import { PlayFilters, usePlayFilters } from "@/components/PlayFilters";

export function ViewerHeader({ team }) {
  const nav = useNavigate();
  const leave = () => { localStorage.removeItem("tpc_viewer"); nav("/join"); };
  return (
    <header className="sticky top-0 z-40 bg-[#0B1528] border-b border-[#1F3358]">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <Logo />
        <div className="flex items-center gap-2">
          <span className="hidden sm:inline-flex items-center gap-1 text-xs font-bold text-slate-300 bg-[#111D35] border border-[#1F3358] rounded-full px-3 py-1" data-testid="viewer-readonly-badge"><Eye size={14} />View only{team && ` · ${team.name}`}</span>
          <button onClick={leave} className="btn btn-ghost px-3" data-testid="viewer-leave-btn"><LogOut size={18} /><span className="hidden sm:inline">Leave</span></button>
        </div>
      </div>
    </header>
  );
}

export default function ViewerPlaybook() {
  const [team, setTeam] = useState(null);
  const [plays, setPlays] = useState(null);
  const [err, setErr] = useState("");
  const f = usePlayFilters(plays || []);
  useEffect(() => {
    Promise.all([viewerApi.get("/viewer/team"), viewerApi.get("/viewer/plays")])
      .then(([t, p]) => { setTeam(t.data); setPlays(p.data); })
      .catch((e) => setErr(errMsg(e)));
  }, []);

  return (
    <div className="min-h-screen bg-[#070D18] text-white">
      <ViewerHeader team={team} />
      <main className="max-w-7xl mx-auto px-3 sm:px-6 py-6">
        {err ? (
          <div className="card p-8 text-center max-w-md mx-auto" data-testid="viewer-error">
            <p className="h2">Can't open this playbook</p>
            <p className="text-slate-400 mt-2">{err}</p>
            <Link to="/join" className="btn btn-primary mt-5" data-testid="viewer-enter-code">Enter a team code</Link>
          </div>
        ) : !plays ? <p className="text-slate-400">Loading…</p> : (
          <>
            <p className="label">{team.name} · Team playbook</p>
            <h1 className="h1 mb-2">Our plays</h1>
            <p className="text-slate-400 mb-6">Tap a play, pick your position, and press <b>Show My Job</b>.</p>
            <PlayFilters f={f} showFav={false} />
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="viewer-playbook-grid">
              {f.filtered.map((p) => <PlayCard key={p.id} play={p} team={team} learnTo={`/view/play/${p.id}`} />)}
            </div>
          </>
        )}
      </main>
    </div>
  );
}
